let DeviceUtil = require("../util/DeviceUtil");

let Tabs = mc.widgets.Tabs;

let layout = [
  { mode: "regions", id: "MEDIAL_CHEST", x: 120, y: 90, r: 0 },
  { mode: "regions", id: "HYPOCHONDRIUM", x: 95, y: 130, r: 0 },
  { mode: "regions", id: "SACRUM", x: 340, y: 165, r: 0 },
  { mode: "regions", id: "ANTERIOR_FOREARM", x: 60, y: 158, r: 103 },
  { mode: "regions", id: "DISTAL_ANTERIOR_FOREARM", x: 53, y: 188, r: 103 },
  { mode: "regions", id: "POSTERIOR_FOREARM", x: 404, y: 175, r: 75 },
  { mode: "regions", id: "DORSAL_HAND", x: 245, y: 290, r: 193 },
  { mode: "regions", id: "ANTERIOR_THIGH", x: 97, y: 260, r: 90 },
  { mode: "regions", id: "LATERAL_THIGH", x: 513, y: 260, r: 90 },
  { mode: "regions", id: "POSTERIOR_THIGH", x: 363, y: 260, r: 90 },
  { mode: "regions", id: "PROXIMAL_LATERAL_SHANK", x: 529, y: 336, r: 90 },
  { mode: "regions", id: "DISTAL_LATERAL_SHANK", x: 529, y: 371, r: 90 },
  { mode: "regions", id: "DORSAL_FOOT", x: 43, y: 380, r: 90, k: "skewY(15) scale(0.9 1.1)" },
  { mode: "regions", id: "FOREHEAD", x: 185, y: 13, r: 0 },
  { mode: "regions", id: "ANTERIOR_NECK", x: 43, y: 58, r: 0 },
  { mode: "regions", id: "EPIGASTRIUM", x: 120, y: 135, r: 0 },
  { mode: "regions", id: "LUMBAR", x: 357, y: 150, r: 0 },
  { mode: "muscles", id: "PECTORALIS", x: 139, y: 99, r: 0 },
  { mode: "muscles", id: "MEDIAL_DELTOID", x: 296, y: 81, r: -20 },
  { mode: "muscles", id: "BICEP", x: 66, y: 132, r: 102 },
  { mode: "muscles", id: "TRICEP", x: 286, y: 132, r: 102 },
  { mode: "muscles", id: "FLEXOR_DIGITORUM", x: 178, y: 167, r: 75 },
  { mode: "muscles", id: "EXTENSOR_DIGITORUM", x: 278, y: 167, r: 106 },
  { mode: "muscles", id: "BRACHIORADIALIS", x: 508, y: 164, r: 108 },
  { mode: "muscles", id: "EXTENSOR_CARPI_RADIALIS_LONGUS", x: 409, y: 166, r: 75, k: "skewY(10) scale(1.0 0.8)"},
  { mode: "muscles", id: "RECTUS_FEMORIS", x: 144, y: 245, r: 90 },
  { mode: "muscles", id: "BICEPS_FEMORIS", x: 313, y: 264, r: 90 },
  { mode: "muscles", id: "TIBIALIS_ANTERIOR", x: 142, y: 339, r: 100 },
  { mode: "muscles", id: "GASTROCNEMIUS", x: 322, y: 347, r: 90 },
  { mode: "muscles", id: "RECTUS_ABDOMINIS", x: 110, y: 180, r: 0 },
  { mode: "muscles", id: "TRAPEZIUS", x: 320, y: 88, r: 0 },
  { mode: "muscles", id: "RHOMBOIDEUS", x: 323, y: 110, r: 0 },
  { mode: "muscles", id: "LATISSIMUS_DORSI", x: 320, y: 138, r: 0 },
  { mode: "muscles", id: "ABDOMINAL_OBLIQUE", x: 490, y: 151, r: -20 },
  { mode: "muscles", id: "GLUTEUS_MAXIMUS", x: 360, y: 202, r: 0 },
  { mode: "spine", id: "CERVICAL_SPINE", x: 274, y: 80, s: 1.75, r: 0 },
  { mode: "spine", id: "UPPER_THORACIC_SPINE", x: 274, y: 145, s: 1.75, r: 0 },
  { mode: "spine", id: "MID_THORACIC_SPINE", x: 274, y: 230, s: 1.75, r: 0 },
  { mode: "spine", id: "LUMBAR_SPINE", x: 274, y: 325, s: 1.75, r: 0 },
  { mode: "cardio", id: "ECG_LEAD_I", x: 485, y: 140, s: 1.75, r: 0 },
  { mode: "cardio", id: "ECG_LEAD_II", x: 485, y: 210, s: 1.75, r: 45 },
  { mode: "cardio", id: "ECG_LEAD_III", x: 485, y: 280, s: 1.75, r: 135 }
];

class BodyMap extends React.Component {
  constructor(props) {
    super(props);

    let selected = props.selected;
    let mode = this.getMode(selected);

    this.state = {
      mode,
      selected
    };
  }

  componentDidUpdate(prevProps, prevState) {
    let { selected } = this.props;

    if (prevProps.selected !== selected) {
      this.setState({
        selected,
        mode: this.getMode(selected)
      });
    }
  }

  getMode(selected) {
    return layout.find((loc) => loc.id === selected).mode;
  }

  setMode(value, changed) {
    if (changed) {
      this.setState({
        mode: value
      });
    }
  }

  setLocation(id) {
    this.props.onSelect(id);
  }

  render() {
    let { selected } = this.props;
    let { mode } = this.state;
    let disabled = this.props.disabled;

    let icons = layout.filter((loc) => loc.mode === mode).map((loc) => {
      let transform = "translate(" + loc.x + "," + loc.y + ") scale(" + (loc.s || 1) + ")";

      return (
        <g
          key={loc.id}
          className="rc-body-map-target"
          aria-pressed={loc.id === selected}
          transform={transform}
          onClick={disabled ? false : this.setLocation.bind(this, loc.id)}>
          {(loc.id === selected || !disabled) && (<circle
            cx="15"
            cy="15"
            r="15"
              data-tooltip={tx(loc.id)}/>)}
          <g transform={"translate(15 15) rotate(" + loc.r + ")" + (loc.k || "")}>
            <image
              xlinkHref="./img/rc/location.svg"
              width="20"
              height="10"
              transform="translate(-10 -5)"/>
          </g>
        </g>
      );
    });

    let opts = ["regions", "muscles", "cardio", "spine"].map(function (value) {
      return { value, label: tx(value) };
    });

    return (
      <div className="rc-body-map">
        {!disabled && (
        <div>
          <Tabs options={opts} value={mode} onSelect={this.setMode.bind(this)}/>
        </div>
        )}
        <svg width="600" height="450">
          <image xlinkHref={`./img/rc/body.${mode}.svg`} width="600" height="450"/>
          {icons}
        </svg>
      </div>
    );
  }
}

module.exports = BodyMap;